import { Link } from "react-router-dom";
import { Spark } from "@/components/viz/Spark";

const nf = (x: number) => (Math.abs(x ?? 0) >= 100000
  ? Intl.NumberFormat("id-ID", { notation: "compact", maximumFractionDigits: 1 }).format(x)
  : Intl.NumberFormat("id-ID").format(x ?? 0));

/** Kartu statistik berwarna. Warna di sini DEKORATIF (identitas dibawa label +
 *  ikon), jadi tidak ikut aturan palet mark — tone data tetap pakai --mark-*. */
export function Tile({ c, icon, label, value, sub, deltaPct, goodWhenUp = true, spark, href }: {
  c: 1 | 2 | 3 | 4 | 5; icon: string; label: string; value: number; sub?: string;
  deltaPct?: number | null; goodWhenUp?: boolean; spark?: number[]; href?: string;
}) {
  const dir = deltaPct == null || Math.abs(deltaPct) < 0.5 ? null : deltaPct > 0 ? "up" : "down";
  const good = dir ? (dir === "up") === goodWhenUp : null;
  const inner = (
    <>
      <span className="avio-tile__top">
        <span className="avio-tile__ico"><i className={icon} /></span>
        <span className="avio-tile__label">{label}</span>
      </span>
      <span className="avio-tile__value">{nf(value)}</span>
      <span className="avio-tile__foot">
        {dir && (
          <span className="avio-tile__pill">
            <i className={dir === "up" ? "fa-solid fa-arrow-up" : "fa-solid fa-arrow-down"} style={{ fontSize: 9 }} />
            {Math.abs(deltaPct!).toFixed(0)}%
            <span style={{ opacity: .8 }}>{good ? "" : ""}</span>
          </span>
        )}
        {sub && <span>{sub}</span>}
      </span>
      {spark && spark.length > 1 && (
        <span className="avio-tile__spark"><Spark data={spark} color="rgba(255,255,255,.9)" w={72} h={26} /></span>
      )}
    </>
  );
  return href
    ? <Link to={href} className="avio-tile" data-c={c}>{inner}</Link>
    : <div className="avio-tile" data-c={c}>{inner}</div>;
}
